import { TraderDetailsPage } from 'features/traders';

export const TechOperatorTraderDetails: React.FC = () => <TraderDetailsPage />;
